import {
    call,
    put,
    all,
    takeLeading
} from 'redux-saga/effects'
import {
    mcbqs010InitInfo,
    setMCBQS010InitInfo,
    setDialogOpen,
    mcbqs010DowloadFlie,
} from 'reducers/outputFileSelectReducer'

import { initRequest, dowloadFlieRequest } from 'apis/MCBQS010Api'
import { openModal, openModalWithArg } from 'reducers/messageReducer'
import { routeList } from 'routes/routes'

// 初期表示処理
function* mcbqs010InitInfoSaga(action: ReturnType<typeof mcbqs010InitInfo>) {
    try {
        const data = yield call(initRequest, action.payload)
        // 画面用データを設定する。
        yield put(setMCBQS010InitInfo(data))
        // モデル表示フラグ「true」を設定する。
        yield put(setDialogOpen(true))


    } catch (error) {
        yield put(openModal(error.message))
    }
}

// 「出力する」ボタン押下
function* mcbqs010DowloadFlieSaga(action: ReturnType<typeof mcbqs010DowloadFlie>) {
    try {


        // 画面用データを設定する。
        const data = yield call(dowloadFlieRequest, action.payload)
        //【MCBQS020_PDF作成中（セット出力）（個別）】画面へ遷移する
       if(data && data !=null && data !=''){
            // モデル表示フラグ「false」を設定する。
            yield put(setDialogOpen(false))
            const windowSize = {
                height: '600px',
                width: '650px',
            }
            localStorage.setItem(
                'setPrintManagementId',
                JSON.stringify({
                    setPrintManagementId:String(data), //セット出力管理IDを設定する
                })
            )
            window.open(
                routeList.pdfMaking,
                'pdfMaking',
                `width=${windowSize.width}, height=${windowSize.height}, resizable=yes`
            )
       }
       

    } catch (error) {
        const messResult: Array<string> = error.message.split(',')
        if (messResult.length == 1) {
            yield put(openModal(messResult[0]))
        } else {
            const [messageId, ...args] = messResult
            yield put(openModalWithArg({ messageId, args }))
        }
    }
}


export default function* accountSaga() {
    yield all([
        takeLeading(mcbqs010InitInfo, mcbqs010InitInfoSaga),
        takeLeading(mcbqs010DowloadFlie, mcbqs010DowloadFlieSaga),
    ])
}

